import React, { PureComponent } from "react";
import {
  CircularProgress,
  FormControl,
  Grid,
  Typography,
} from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import Error from "@material-ui/icons/Error";
import { withStyles, createStyles, WithStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { validateFileExts } from "../../utils";

const styles = (theme: Theme) =>
  createStyles({
    inputFile: {
      display: "none",
    },
    inputLabel: {
      cursor: "pointer",
    },
    previewContainer: {
      position: "relative",
      margin: "10px 10px 10px 0",
    },
    cancelIcon: {
      position: "absolute",
      top: 0,
      right: 0,
      cursor: "pointer",
    },
    loadingProgress: {
      position: "absolute",
      top: "35%",
      left: "35%",
    },
    errorText: {
      color: theme.palette.error.light,
      verticalAlign: "middle",
      marginTop: "3px",
      "& svg": {
        verticalAlign: "bottom",
        marginRight: '5px',
      },
    },
    marginTop: {
      marginTop: "1rem",
      "&>:last-child": {
        marginRight: 0,
      },
      "& label": {
        fontSize: "1rem",
        color: "#1d7dea",
      },
    },
    maxAllowedText: {
      fontWeight: "normal",
      fontSize: "0.8rem",
      color: "#666",
    },
  });

interface Props extends WithStyles<typeof styles> {
  onChange: (data: File[]) => void;
  maxNoOfSelections?: number;
  loading?: boolean;
  showPreview?: boolean;
  accept?: string;
  multiple?: boolean;
  allowedFileTypes?: string[];
}

interface State {
  images: File[];
  error: boolean;
  errorMsg: string;
}

class MyPATImageUploader extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      images: [],
      error: false,
      errorMsg: "",
    };
  }

  handleAttachmentsOnChange = (e: any) => {
    const { maxNoOfSelections, allowedFileTypes } = this.props;
    const files: File[] = Array.from(e.target.files);

    if (maxNoOfSelections !== undefined && files.length > maxNoOfSelections) {
      this.setState({
        error: true,
        errorMsg: `You can only select ${maxNoOfSelections} attachments.`,
      });
    } else {
      let validationResult = true;
      if (allowedFileTypes) {
        validationResult = files.reduce(
          (acc: boolean, { type }) =>
            acc && validateFileExts(type, allowedFileTypes),
          true
        );
      }

      if (!validationResult && allowedFileTypes) {
        this.setState({
          error: true,
          errorMsg: `Only ${allowedFileTypes.join(", ")} are allowed.`,
        });
      } else {
        this.setState(
          {
            error: false,
            errorMsg: "",
            images: files,
          },
          () => this.props.onChange(this.state.images)
        );
      }
    }
  };

  handleRemovingAttachment = (i: number) => {
    this.setState(
      (prevState) => {
        const images = prevState.images.filter((_, index) => index !== i);
        return {
          ...prevState,
          images,
        };
      },
      () => this.props.onChange(this.state.images)
    );
  };

  render() {
    const { images, error, errorMsg } = this.state;
    const {
      accept,
      multiple,
      showPreview,
      classes,
      loading,
      maxNoOfSelections,
    } = this.props;
    return (
      <Grid container className={classes.marginTop}>
        <Grid item xs={12}>
          <FormControl>
            <label htmlFor="attachments" className={classes.inputLabel}>
              Add attachments{" "}
            </label>
            {maxNoOfSelections !== undefined && (
              <Typography
                variant="subtitle1"
                className={classes.maxAllowedText}
              >
                Only {maxNoOfSelections} allowed
              </Typography>
            )}
            <input
              id="attachments"
              aria-describedby="Add attachments"
              type="file"
              accept={accept || ""}
              onChange={this.handleAttachmentsOnChange}
              multiple={multiple || false}
              className={classes.inputFile}
            />
            {error && (
              <Typography
                className={classes.errorText}
                variant="caption"
                color="error"
              >
                <Error />
                {errorMsg}
              </Typography>
            )}
          </FormControl>
        </Grid>
        {showPreview && images.length > 0 && (
          <Grid
            container
            item
            xs={12}
            wrap="wrap"
            className={classes.marginTop}
          >
            <Grid item xs={12}>
              <Typography variant="h6">Preview:</Typography>
            </Grid>
            {images.map((image, i) => {
              const previewUrl = URL.createObjectURL(image);
              console.log(previewUrl);
              return (
                <Grid item key={i} className={classes.previewContainer}>
                  {!loading && (
                    <CancelIcon
                      className={classes.cancelIcon}
                      onClick={() => this.handleRemovingAttachment(i)}
                    />
                  )}
                  {loading && (
                    <CircularProgress className={classes.loadingProgress} />
                  )}
                  <img
                    src={previewUrl}
                    alt={`attachment-${i + 1}`}
                    height="130"
                    width="130"
                  />
                </Grid>
              );
            })}
          </Grid>
        )}
      </Grid>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(MyPATImageUploader);
